import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getServiceLines } from "@/src/requests/service-lines";
export const SERVICE_LINES_CACHE_KEY = "service-lines";
export function useServiceLines() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: [SERVICE_LINES_CACHE_KEY],
      queryFn: getServiceLines,
      staleTime: Infinity,
      gcTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}